import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PercentIcon from '@mui/icons-material/Percent'
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent'
import { useSelector } from 'react-redux'
import '../../css/Badges.css'

const Badges = ({ articulo }) => {
  const precio = useSelector(
    state => state?.precios?.precio[articulo.codigo_articulo]?.[articulo?.presentacion_web],
  )

  return articulo != null ? (
    <div className='article-list-badges'>
      {precio?.reservado_a01 ? (
        <div
          className='badge-reservado'
          dangerouslySetInnerHTML={{ __html: precio.reservado_a01 }}></div>
      ) : (
        <></>
      )}
      {articulo?.es_novedad === 'S' ? (
        <div className='badge-novedad'>
          <WbIncandescentIcon />
        </div>
      ) : null}
      {articulo?.es_oferta === 'S' ? (
        <div className='badge-oferta'>
          <PercentIcon />
        </div>
      ) : null}
      {articulo?.es_reciente === 'S' ? (
        <div className='badge-comprado-reciente'>
          <AccessTimeIcon />
        </div>
      ) : null}
    </div>
  ) : null
}

export default Badges
